var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"link",class:{"atag-gray" : _vm.disabled === true },attrs:{"href":"javascript:void(0)"},on:{"click":_vm.show}},[_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }